import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CategoryService {

constructor(private http:HttpClient) { }
getCompounds(){
  return this.http.get<any[]>(environment.apiUrl+"category")
}

addCompounds(model:any){
return this.http.post(environment.apiUrl+"category",model);
}

editCompounds(model:any,id:any){
  return this.http.put(environment.apiUrl+"category/"+id,model);
  }

deleteCompounds(id:any){
  return this.http.delete(environment.apiUrl+"category/"+id);
  }
}
